export default {"src":"/_next/static/media/meta.aca93b40.svg","height":15,"width":69,"blurWidth":0,"blurHeight":0};